<template>
  <v-app :class="`page-${$route.name}`">
    <app-bar></app-bar>
    <v-main>
      <router-view :key="$route.path"></router-view>
    </v-main>
    <footer-bar></footer-bar>
    <!-- MAR-1042 Commented the cookie banner as we don't store any cookies but for future can re use this -->
    <!-- <cookie></cookie> -->
    <cookies-dialog></cookies-dialog>
    <notifications></notifications>
  </v-app>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import AppBar from '@/components/layout/AppBar';
import Notifications from '@/components/layout/Notifications';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    AppBar,
    Notifications,
    FooterBar: defineAsyncComponent(() =>
      import('@/components/layout/FooterBar')
    ),
    // MAR-1042 Commented the cookie banner as we don't store any cookies but for future can re use this
    // Cookie: defineAsyncComponent(() => import('@/components/layout/Cookie')),
    CookiesDialog: defineAsyncComponent(() =>
      import('@/components/layout/panels/CookiesDialog')
    )
  },
  computed: {
    ...mapGetters('branding', ['brand'])
  },
  methods: {
    ...mapActions('facilities', ['setHotelFacilities']),
    ...mapActions('branding', ['fetchBranding']),
    /*
     * The static theme seeds Vuetify's `primary` at plugin creation; once the
     * Airtable row is in, repoint it so every color="primary" surface (app bar,
     * buttons, links, the SCSS `$primary` var) follows the tenant's brand colour.
     */
    applyBrand() {
      document.title = this.brand.title;
      const themes = this.$vuetify.theme.themes;
      const light = themes.value ? themes.value.light : themes.light;
      if (light && this.brand.color) {
        light.colors.primary = this.brand.color;
      }
    }
  },
  created() {
    this.applyBrand();
    this.setHotelFacilities();
    this.fetchBranding().then(() => this.applyBrand());
  }
};
</script>

<style lang="scss">
@import 'src/scss/utils/__utils';
/*
 * Vuetify 3 renders `.v-container`, so the v2 cap below never matched and every
 * container ran 1200px wide with 16px gutters — which is why the header logo no
 * longer lined up with the page content beneath it.
 */
.v-application {
  .container,
  .v-container {
    padding: 12px;
  }
}
@media (min-width: 1200px) {
  .v-application {
    .container,
    .v-container {
      max-width: 1144px;
    }
  }
}
@media (max-width: 767px) {
  .v-main {
    padding-top: $header-height-m !important;
  }
  .page-details {
    padding-bottom: 68px;
    .v-main {
      padding-top: $header-height-m-details !important;
    }
  }
}
</style>
